var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.25 19.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e95c28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 0.21,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 2.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 4.45,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 6.56,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 8.68,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 10.8,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 12.92,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 15.04,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 17.16,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.21,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.33,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.45,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.56,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.68,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.8,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.92,
    cy: 19.28,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.04,
    cy: 19.28,
    r: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.b9333a03b9dc7e497a52e39509ae79b7.svg";
export { ForwardRef as ReactComponent };